import _ from 'lodash'





let utils = {
    _,
    validate:()=>{
        
    }
}

export default utils